<template>

    <div class="lang-selector">
      <div v-if="unique" v-for="(item, index) in lang" class="item" :class="{'selected': item.name === language}" :key="item.name" @click="selectLang(item)">{{item.name}}</div>
      <div v-if="!unique" class="item selected">{{Object.values(lang)[0].name}}</div>
    </div>

</template>

<script>


export default {
  name: 'LangSelector',
  props: {string: String, refresh: Boolean, unique: Boolean},
  data () {
    return {
    }
  },
  computed: {
    lang() {
      return this.$store.state.languages;
    },
    language() {
      return this.$store.state.language;
    }
  },
  methods: {
    selectLang(lang) {
      this.$store.commit('setLanguage', lang.name);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .lang-selector {
    margin: 0px;
    float: right;
    margin-top: 20px;

    .item {
      width: fit-content;
      padding: 2px 8px;
      color: #999;
      float: left;
      cursor: pointer;
      text-transform: uppercase;

      &.selected {
        background: var(--main_color);
        font-family: Speedee-Bold;
        color: var(--dark_color);
      } 
    }
  }

</style>
